import React, {useState} from "react"
import {Lightbox} from "../Components/Lightbox"
import {LIGHTBOX__GALLERY} from "../Hooks/Lightbox"
import style from "./Gallery.css"
import * as DOMPurify from 'dompurify';
import {iconArrowLeft, iconArrowRight} from "../Helper/Icons"

export const Gallery = ({product}) => {
    const [currentDisplayIndex, setCurrentDisplayIndex] = useState(0)
    const [galleryImageUrls] = useState(getSortedImageUrls())
    
    const display = getDisplayImage()
    const navigation = getGalleryNavigation()
    
    const showNextImage = () => {
        if (currentDisplayIndex === galleryImageUrls.length - 1) {
            setCurrentDisplayIndex(0)
        } else {
            setCurrentDisplayIndex(currentDisplayIndex + 1)
        }
    }

    const showPreviousImage = () => {
        if (currentDisplayIndex === 0) {
            setCurrentDisplayIndex(galleryImageUrls.length - 1)
        } else {
            setCurrentDisplayIndex(currentDisplayIndex - 1)
        }
    }

    const showImage = (index) => {
        setCurrentDisplayIndex(index)
    }

    function getSortedImageUrls() {
        const sortedMediaGallery = product.mediaGallery.sort(
            function compare(alpha, beta) {
                return alpha.position - beta.position
            }
        )
        return sortedMediaGallery.map(element => element.url)
    }

    function getGalleryNavigation() {
        return galleryImageUrls.map((url, index) => {
            return <img className={index === currentDisplayIndex ? style.activeThumbnail : ''} onClick={() => showImage(index)} key={index} src={url} alt={product.name}/>
        })
    }

    function getDisplayImage() {
        return <div style={{backgroundImage: `url("${galleryImageUrls[currentDisplayIndex]}")`}} />
    }
    
    return <Lightbox type={LIGHTBOX__GALLERY}>
        <div className={style.container}>
            <div className={style.leftColumn}>
                <div className={style.product}>
                    <div className={style.image} style={{backgroundImage: `url('${product.imageUrl}')`}}/>
                    <div className={style.name}>{product.name}</div>    
                    <div className={style.title}>{product.title}</div>    
                    <div className={style.description} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(product.description)}}></div>   
                </div>
            </div>
            <div className={style.rightColumn}>
                <div className={style.media}>
                    <div className={style.leftArrow} onClick={showPreviousImage}>
                        {iconArrowLeft}
                    </div>
                    <div className={style.viewbox}>
                        <div className={style.display}>
                            {display}
                        </div>
                        <div className={style.navigation}>
                            {navigation}
                        </div>
                    </div>
                    <div className={style.rightArrow} onClick={showNextImage}>
                        {iconArrowRight}
                    </div>
                </div>    
            </div>
        </div>
    </Lightbox>
}